import React from 'react'

const Topic = ( { topicData } ) => {
  return (
    <div className='tags__tag'>
        {topicData}
    </div>
  )
}

export default Topic
